
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginM27KibMjq6cSb3p_45JKb9nrk1MT9mGSkQndOvAegQkYMMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/login.vue?macro=true";
import { default as tosmB46Xn9hMAyJOy5OI2sHP3SXn9lP0ZtN_4xTYjr6_45GMMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/tos.vue?macro=true";
import { default as registerLoBiOauZ1NASCmFRulcqWDWv9v1Je_45CC938o6vomgJEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/register.vue?macro=true";
import { default as hmnbOr_rtLQ_LUyvSIWsf7NRN4whyqG9tITVF_45oea0hFIVMMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/hmnb.vue?macro=true";
import { default as pdf_45previewaaWISi9kXLOpfXQ0b5g5SsU7jB_45oNfstNhCOmn6wq3sMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/pdf-preview.vue?macro=true";
import { default as indexTpoparH27QDczz7Djvbv0bKM_tfV1uVjhkKZbbKw42wMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/start/index.vue?macro=true";
import { default as bgsc_45KOV8mSACTF_45quFJgL3hCiiQ_45oybhAlqPYO6WcHlK6gMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/bgsc.vue?macro=true";
import { default as bgylbfRhjCwNdoV9POdMpxxPW7kLCoEDSohK8LNavfk_rZEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/bgyl.vue?macro=true";
import { default as xtszJAvH7ut_45UUOJbUZ4G0B61qbWQKltDy_9W6EP8_Ox_45gAMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/xtsz.vue?macro=true";
import { default as yhglNc98Iu42dIKnudwnQKIFEtwg0kDP4iPZVEP3YNBSPIwMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/yhgl.vue?macro=true";
import { default as privacy63prGGrHen0oV80aBOt8n86i_45mRE5CfDxdFtSSwBJIQMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/privacy.vue?macro=true";
import { default as jdesg2Mjgu_nXRX_45KahvhBVD0docZXqHed5nJYfgalJavuzgMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jdesg.vue?macro=true";
import { default as hotel_45viewerPrgw33WNvhtoUBdlJ2FZ_wv2yxCHZ6nGmEkbftGV_45fsMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hotel-viewer.vue?macro=true";
import { default as utils1rOAFf5k93jY5aPvODH0aeopAzcYnNzDdUTSnn1QM4MMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/datapage/utils.ts?macro=true";
import { default as ydsjcxxDXKnPW0UlG1POy2qEt_J3UO_gYv9_8BdaLZwc6SwoEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/ydsjcx.vue?macro=true";
import { default as ydsjshYlM6UsZ6cVu8lXOxjCneKE7BY0tSyXgXrIE4ebILf3YMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/ydsjsh.vue?macro=true";
import { default as jdyhgl1_UeeUGlGyPUMPrefKhP8B99SQH_45187VR09rg6IvZB4Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/jdyhgl.vue?macro=true";
import { default as qtyhgl8pMklxXimIAhbSoxsu2VG2YlbpbZz3Z5RXNwQeCui0MMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/qtyhgl.vue?macro=true";
import { default as pgyzw2BisITqy9Bb7EaIrRvJVfCMkqq3C3e_Nj3wthD06gcQMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/pgyzw.vue?macro=true";
import { default as wlbtjbgXZfE1X6pW4mqr9Oe1W9qLDLuubDKcNlAepPwd4LjYBQMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/wlbtjbg.vue?macro=true";
import { default as jcsjtbP2jiMMvX_45wFr5_456gF2kd9TBYQ_45mR_1pxVq1ZdMoMb30Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jcsjtb.vue?macro=true";
import { default as jdjyfxqQD9HhYvq8WgJg1d_PSWQE5W4MKhce_ABQefTuUuXvIMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jdjyfx.vue?macro=true";
import { default as jzzqtbH7uw7Chv9surd6oyBqPhcIFoxVElWGgOiUBABJdMoi0Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jzzqtb.vue?macro=true";
import { default as ndjyfxZ6zU5S4wA6kD_LVr2l3nNQZJKvuYBmoGkWUlVb_45zwCQMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ndjyfx.vue?macro=true";
import { default as ydjyfxu0YAP6nm_KutPj1SiKAcFUILtaWb4Ouztf66Tg29fVgMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ydjyfx.vue?macro=true";
import { default as ydsjtb54sAYyJ8ppYEVRPI6YAJJoRlXqs18KGl3SsYK009c7IMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ydsjtb.vue?macro=true";
import { default as password_45resetqICIiKfr0RHNFWJB0uUsB9ZODRzJVFjmWRqBMMIUogcMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/password-reset.vue?macro=true";
import { default as pgyzwACZGYlj1HnsY_CDgdNFePlMcP0XxqQjr42EFa1b47fUMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/pgyzw.vue?macro=true";
import { default as jdjyfxJE578Z5lJSaj_450a3SEYf9KbNnybPHFh_B9DsMPvzOs4Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/jdjyfx.vue?macro=true";
import { default as ndjyfxwO8Z0g_6BuTnBBEb2SJnWUMI2UKIFuOBIHMzK6Utwx0Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ndjyfx.vue?macro=true";
import { default as ndjyycyqqIoG36m8TWrhbi5mUQPcckMKMVycnzgpA5UIWNjhsMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ndjyyc.vue?macro=true";
import { default as ydjyfxatiVsq5uhxb7qnTdG0GIOmcij6CDsh9MPRdnCaWQOKYMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ydjyfx.vue?macro=true";
import { default as datareportSarpFKcuEExXUkfQjxXiUmpk45Uh1YrtT8RHWaE7lPAMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/datareport.vue?macro=true";
import { default as disclaimertuVmb0CvCNKrIYu1KO3ohfAePmxdLlUoqYsFPDtKIdYMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/disclaimer.vue?macro=true";
import { default as jgjtjdcb6qmEEZI5CkHthGldas0phmStPgcSUKkKzkMpeiaw4KsMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtjdcb.vue?macro=true";
import { default as jdjyfxMd37Ipr49BXEnCpMwImsOOLt9R8jGev6EpDT7wodTn4Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/jdjyfx.vue?macro=true";
import { default as ndjyfx8M6dHKjGGlAzo5VuS_oa4RzZXCww_457a_m4J9RIRR2TkMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/ndjyfx.vue?macro=true";
import { default as ydjyfxrvo0KZppAPBOJyCCx6GzDKq6LxdOLjRdWTjZt5KuiaEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/ydjyfx.vue?macro=true";
import { default as companyListDdMPdB_CDNn_GiwXOkMnP_I_9MYfQzMwZ5VAoTKxKVQMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/companyList.ts?macro=true";
import { default as jgjtReports_45_BJQ25optyPwTNxaFRijDuN2Cm18O6rSQcAvOkwIogMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtReports.ts?macro=true";
import { default as sampleTaskshsEoR4_45ndF4HX3wON5JNgt6JvkWS_NSm_gB_457km5oXEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/sampleTasks.ts?macro=true";
import { default as jgjtjdcb_45xqanpjBgj2Swbbvf9epAVMkaowmgqd3WEE7gOCdd2QLuIMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtjdcb-xq.vue?macro=true";
import { default as indexayDwl7DFMXizeqq9vASEx4uTQck6VlN_450dQpA8R_45ZtcMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hotel-manage/index.vue?macro=true";
import { default as report_45task8d_GWXRArXO9twZ0UuuzkpQHmjiu1jgxKtGloYKLc8wMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/report-task.vue?macro=true";
import { default as _91dataPage_93_45DPyhXEF4hCUZjtfXyFVytSvJq9qqNdnARKfjr1TfrEMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/datapage/[dataPage].vue?macro=true";
import { default as sampleReportslJ7d9DU1tNRH9Jq_45YLGGho655KX28uaAZzcI3e1htl4Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/sampleReports.ts?macro=true";
import { default as _91sectionName_93YDuCCtjEu82jhDCAmdht1TQ5mwpban0pgV9d0c6AyLIMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/[sectionName].vue?macro=true";
import { default as siteConfigc0hmeH8FAcQv3DNOQvmnTJadiWeT2jpD27B1AjpTgG0Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/start/startUtils/siteConfig.ts?macro=true";
import { default as _91organizationId_93jo48tZRSUZ4N5UJHq7_JbLETY_45vUwKSu5Bst3d3G_45SIMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/user-manage/[organizationId].vue?macro=true";
import { default as getAdFilesz4iXvoV8_PddzDNralKJPXwc_wR4CuTr03aTvV2UiakMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getAdFiles.ts?macro=true";
import { default as brandsMNXgl3lE3mdj3VFc3YcNNE7eiaQgx_45k7zZNDPKqHsYAMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/utils/brands.ts?macro=true";
import { default as citiesdc0hLgXv3DYgEXij0dglo1GIVu9dVhreBCqqNL6AaxgMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/utils/cities.ts?macro=true";
import { default as huameiAnnualsQXtU69y0BPurMFkhrr_45BD5SrStPkwUzxfXhnMq2XmKYMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/huameiAnnuals.ts?macro=true";
import { default as getPageContentTFmIo1nbMvahwcYe5GOLxI0shchH_M1d3oFNIBR2SB0Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getPageContent.ts?macro=true";
import { default as displayProjects7AVxvZFvl5xNHPxLyThghEO9P4zPBRc42K3q_45GYRrr8Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/displayProjects.ts?macro=true";
import { default as processLeftMenu_hBzHz70vfbVGV7fSyYqD8N19ahMxd4S3GpYoa5dJScMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/processLeftMenu.ts?macro=true";
import { default as getCategory1Options3Nlz_45SETTQTsbqTWrZ8a8maU6esjT2E8plaeGjfx8ksMeta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getCategory1Options.ts?macro=true";
import { default as getPageContentOverrideE_459YTgLzC4zDieuhivN8XmbHifkXXQqA1ts8KlumIL4Meta } from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getPageContentOverride.ts?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/login.vue")
  },
  {
    name: "docs-tos",
    path: "/docs/tos",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/tos.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/register.vue")
  },
  {
    name: "hangye-hmnb",
    path: "/hangye/hmnb",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/hmnb.vue")
  },
  {
    name: "pdf-preview",
    path: "/pdf-preview",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/pdf-preview.vue")
  },
  {
    name: "start",
    path: "/start",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/start/index.vue")
  },
  {
    name: "xiehui-bgsc",
    path: "/xiehui/bgsc",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/bgsc.vue")
  },
  {
    name: "xiehui-bgyl",
    path: "/xiehui/bgyl",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/bgyl.vue")
  },
  {
    name: "xitong-xtsz",
    path: "/xitong/xtsz",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/xtsz.vue")
  },
  {
    name: "xitong-yhgl",
    path: "/xitong/yhgl",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/yhgl.vue")
  },
  {
    name: "docs-privacy",
    path: "/docs/privacy",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/privacy.vue")
  },
  {
    name: "hangye-jdesg",
    path: "/hangye/jdesg",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jdesg.vue")
  },
  {
    name: "hotel-viewer",
    path: "/hotel-viewer",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hotel-viewer.vue")
  },
  {
    name: "datapage-utils",
    path: "/datapage/utils",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/datapage/utils.ts")
  },
  {
    name: "xiehui-ydsjcx",
    path: "/xiehui/ydsjcx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/ydsjcx.vue")
  },
  {
    name: "xiehui-ydsjsh",
    path: "/xiehui/ydsjsh",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/ydsjsh.vue")
  },
  {
    name: "xitong-jdyhgl",
    path: "/xitong/jdyhgl",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/jdyhgl.vue")
  },
  {
    name: "xitong-qtyhgl",
    path: "/xitong/qtyhgl",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xitong/qtyhgl.vue")
  },
  {
    name: "chengshi-pgyzw",
    path: "/chengshi/pgyzw",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/pgyzw.vue")
  },
  {
    name: "hangye-wlbtjbg",
    path: "/hangye/wlbtjbg",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/wlbtjbg.vue")
  },
  {
    name: "jiudian-jcsjtb",
    path: "/jiudian/jcsjtb",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jcsjtb.vue")
  },
  {
    name: "jiudian-jdjyfx",
    path: "/jiudian/jdjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jdjyfx.vue")
  },
  {
    name: "jiudian-jzzqtb",
    path: "/jiudian/jzzqtb",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/jzzqtb.vue")
  },
  {
    name: "jiudian-ndjyfx",
    path: "/jiudian/ndjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ndjyfx.vue")
  },
  {
    name: "jiudian-ydjyfx",
    path: "/jiudian/ydjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ydjyfx.vue")
  },
  {
    name: "jiudian-ydsjtb",
    path: "/jiudian/ydsjtb",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/jiudian/ydsjtb.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/password-reset.vue")
  },
  {
    name: "shengfen-pgyzw",
    path: "/shengfen/pgyzw",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/pgyzw.vue")
  },
  {
    name: "chengshi-jdjyfx",
    path: "/chengshi/jdjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/jdjyfx.vue")
  },
  {
    name: "chengshi-ndjyfx",
    path: "/chengshi/ndjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ndjyfx.vue")
  },
  {
    name: "chengshi-ndjyyc",
    path: "/chengshi/ndjyyc",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ndjyyc.vue")
  },
  {
    name: "chengshi-ydjyfx",
    path: "/chengshi/ydjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/chengshi/ydjyfx.vue")
  },
  {
    name: "docs-datareport",
    path: "/docs/datareport",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/datareport.vue")
  },
  {
    name: "docs-disclaimer",
    path: "/docs/disclaimer",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/docs/disclaimer.vue")
  },
  {
    name: "hangye-jgjtjdcb",
    path: "/hangye/jgjtjdcb",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtjdcb.vue")
  },
  {
    name: "shengfen-jdjyfx",
    path: "/shengfen/jdjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/jdjyfx.vue")
  },
  {
    name: "shengfen-ndjyfx",
    path: "/shengfen/ndjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/ndjyfx.vue")
  },
  {
    name: "shengfen-ydjyfx",
    path: "/shengfen/ydjyfx",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/shengfen/ydjyfx.vue")
  },
  {
    name: "hangye-companyList",
    path: "/hangye/companyList",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/companyList.ts")
  },
  {
    name: "hangye-jgjtReports",
    path: "/hangye/jgjtReports",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtReports.ts")
  },
  {
    name: "xiehui-sampleTasks",
    path: "/xiehui/sampleTasks",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/sampleTasks.ts")
  },
  {
    name: "hangye-jgjtjdcb-xq",
    path: "/hangye/jgjtjdcb-xq",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hangye/jgjtjdcb-xq.vue")
  },
  {
    name: "hotel-manage",
    path: "/hotel-manage",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/hotel-manage/index.vue")
  },
  {
    name: "xiehui-report-task",
    path: "/xiehui/report-task",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/report-task.vue")
  },
  {
    name: "datapage-dataPage",
    path: "/datapage/:dataPage()",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/datapage/[dataPage].vue")
  },
  {
    name: "xiehui-sampleReports",
    path: "/xiehui/sampleReports",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/xiehui/sampleReports.ts")
  },
  {
    name: "section-sectionName",
    path: "/section/:sectionName()",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/[sectionName].vue")
  },
  {
    name: "start-startUtils-siteConfig",
    path: "/start/startUtils/siteConfig",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/start/startUtils/siteConfig.ts")
  },
  {
    name: "user-manage-organizationId",
    path: "/user-manage/:organizationId()",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/user-manage/[organizationId].vue")
  },
  {
    name: "section-sectionUtils-getAdFiles",
    path: "/section/sectionUtils/getAdFiles",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getAdFiles.ts")
  },
  {
    name: "section-sectionUtils-utils-brands",
    path: "/section/sectionUtils/utils/brands",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/utils/brands.ts")
  },
  {
    name: "section-sectionUtils-utils-cities",
    path: "/section/sectionUtils/utils/cities",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/utils/cities.ts")
  },
  {
    name: "section-sectionUtils-huameiAnnuals",
    path: "/section/sectionUtils/huameiAnnuals",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/huameiAnnuals.ts")
  },
  {
    name: "section-sectionUtils-getPageContent",
    path: "/section/sectionUtils/getPageContent",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getPageContent.ts")
  },
  {
    name: "section-sectionUtils-displayProjects",
    path: "/section/sectionUtils/displayProjects",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/displayProjects.ts")
  },
  {
    name: "section-sectionUtils-processLeftMenu",
    path: "/section/sectionUtils/processLeftMenu",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/processLeftMenu.ts")
  },
  {
    name: "section-sectionUtils-getCategory1Options",
    path: "/section/sectionUtils/getCategory1Options",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getCategory1Options.ts")
  },
  {
    name: "section-sectionUtils-getPageContentOverride",
    path: "/section/sectionUtils/getPageContentOverride",
    component: () => import("/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/pages/section/sectionUtils/getPageContentOverride.ts")
  }
]